/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AccessToken,
  Courier,
  CourierPackage,
  CourierUser,
  CourierUserChangePasswordRequest,
  CourierUserCreateWhatsAppUserRequest,
  CourierUserGetUserIdByEmailRequest,
  CourierUserImportFromCsvRequest,
  CourierUserSetPasswordRequest,
  Invoice,
  Mailbox,
  NewCourierPackage,
  NewCourierUser,
  NewInvoice,
  NewMailbox,
  NewPushSubscription,
  NewRole,
  NewRoleMapping,
  PasskeyCredential,
  PushSubscription,
  RewardsAccount,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  StoreLocation,
} from '../models/index';
import {
  AccessTokenFromJSON,
  AccessTokenToJSON,
  CourierFromJSON,
  CourierToJSON,
  CourierPackageFromJSON,
  CourierPackageToJSON,
  CourierUserFromJSON,
  CourierUserToJSON,
  CourierUserChangePasswordRequestFromJSON,
  CourierUserChangePasswordRequestToJSON,
  CourierUserCreateWhatsAppUserRequestFromJSON,
  CourierUserCreateWhatsAppUserRequestToJSON,
  CourierUserGetUserIdByEmailRequestFromJSON,
  CourierUserGetUserIdByEmailRequestToJSON,
  CourierUserImportFromCsvRequestFromJSON,
  CourierUserImportFromCsvRequestToJSON,
  CourierUserSetPasswordRequestFromJSON,
  CourierUserSetPasswordRequestToJSON,
  InvoiceFromJSON,
  InvoiceToJSON,
  MailboxFromJSON,
  MailboxToJSON,
  NewCourierPackageFromJSON,
  NewCourierPackageToJSON,
  NewCourierUserFromJSON,
  NewCourierUserToJSON,
  NewInvoiceFromJSON,
  NewInvoiceToJSON,
  NewMailboxFromJSON,
  NewMailboxToJSON,
  NewPushSubscriptionFromJSON,
  NewPushSubscriptionToJSON,
  NewRoleFromJSON,
  NewRoleToJSON,
  NewRoleMappingFromJSON,
  NewRoleMappingToJSON,
  PushSubscriptionFromJSON,
  PushSubscriptionToJSON,
  RewardsAccountFromJSON,
  RewardsAccountToJSON,
  RoleFromJSON,
  RoleToJSON,
  RoleMappingFromJSON,
  RoleMappingToJSON,
  RoleMappingCount200ResponseFromJSON,
  RoleMappingCount200ResponseToJSON,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
  RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
  RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
  RoleMappingUpdateAll200ResponseFromJSON,
  RoleMappingUpdateAll200ResponseToJSON,
  StoreLocationFromJSON,
  StoreLocationToJSON,
} from '../models/index';

export interface CourierUserChangePasswordOperationRequest {
  courierUserChangePasswordRequest: CourierUserChangePasswordRequest;
}

export interface CourierUserConfirmRequest {
  uid: string;
  token: string;
  redirect?: string;
}

export interface CourierUserCountRequest {
  where?: string;
}

export interface CourierUserCreateRequest {
  data?: NewCourierUser;
}

export interface CourierUserCreateChangeStreamGetCourierUsersChangeStreamRequest {
  options?: string;
}

export interface CourierUserCreateChangeStreamPostCourierUsersChangeStreamRequest {
  roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface CourierUserCreateUserWithTempPasswordRequest {
  userObject: object;
}

export interface CourierUserCreateWhatsAppUserOperationRequest {
  courierUserCreateWhatsAppUserRequest?: CourierUserCreateWhatsAppUserRequest;
}

export interface CourierUserDeleteByIdRequest {
  id: string;
}

export interface CourierUserExistsGetCourierUsersidExistsRequest {
  id: string;
}

export interface CourierUserExistsHeadCourierUsersidRequest {
  id: string;
}

export interface CourierUserExportUsersRequest {
  realm: string;
}

export interface CourierUserExportUsersForQuickBooksRequest {
  realm: string;
}

export interface CourierUserFindRequest {
  filter?: string;
}

export interface CourierUserFindByIdRequest {
  id: string;
  filter?: string;
}

export interface CourierUserFindOneRequest {
  filter?: string;
}

export interface CourierUserGetAdministratorsRequest {
  realm: string;
}

export interface CourierUserResolveReferrerRequest {
  query: string;
  realm: string;
}

export interface ResolvedReferrer {
  referrerId: number;
  name: string;
}

export interface CourierUserGetUserIdByEmailOperationRequest {
  courierUserGetUserIdByEmailRequest?: CourierUserGetUserIdByEmailRequest;
}

export interface CourierUserImportFromCsvOperationRequest {
  courierUserImportFromCsvRequest?: CourierUserImportFromCsvRequest;
}

export interface CourierUserImportUsersFromJsonRequest {
  data: CourierUser;
}

export interface CourierUserLoginRequest {
  credentials: object;
  include?: string;
}

export interface CourierUserPatchOrCreateRequest {
  data?: CourierUser;
}

export interface CourierUserPrototypeCountAccessTokensRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountCourierPackagesRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountInvoicesRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountMailboxesRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountPushSubscriptionRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountReferrerRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountReferrerAccessTokensRequest {
  id: string;
  nk: string;
  where?: string;
}

export interface CourierUserPrototypeCountReferrerReferrerRequest {
  id: string;
  nk: string;
  where?: string;
}

export interface CourierUserPrototypeCountReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  where?: string;
}

export interface CourierUserPrototypeCountReferrerRolesRequest {
  id: string;
  nk: string;
  where?: string;
}

export interface CourierUserPrototypeCountRoleMappingsRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCountRolesRequest {
  id: string;
  where?: string;
}

export interface CourierUserPrototypeCreateAccessTokensRequest {
  id: string;
  data?: AccessToken;
}

export interface CourierUserPrototypeCreateCourierPackagesRequest {
  id: string;
  data?: NewCourierPackage;
}

export interface CourierUserPrototypeCreateInvoicesRequest {
  id: string;
  data?: NewInvoice;
}

export interface CourierUserPrototypeCreateMailboxesRequest {
  id: string;
  data?: NewMailbox;
}

export interface CourierUserPrototypeCreatePushSubscriptionRequest {
  id: string;
  data?: NewPushSubscription;
}

export interface CourierUserPrototypeCreateReferrerRequest {
  id: string;
  data?: NewCourierUser;
}

export interface CourierUserPrototypeCreateReferrerAccessTokensRequest {
  id: string;
  nk: string;
  data?: AccessToken;
}

export interface CourierUserPrototypeCreateReferrerReferrerRequest {
  id: string;
  nk: string;
  data?: NewCourierUser;
}

export interface CourierUserPrototypeCreateReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  data?: NewRoleMapping;
}

export interface CourierUserPrototypeCreateReferrerRolesRequest {
  id: string;
  nk: string;
  data?: NewRole;
}

export interface CourierUserPrototypeCreateRewardsAccountRequest {
  id: string;
  data?: RewardsAccount;
}

export interface CourierUserPrototypeCreateRoleMappingsRequest {
  id: string;
  data?: NewRoleMapping;
}

export interface CourierUserPrototypeCreateRolesRequest {
  id: string;
  data?: NewRole;
}

export interface CourierUserPrototypeDeleteAccessTokensRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteCourierPackagesRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteInvoicesRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteMailboxesRequest {
  id: string;
}

export interface CourierUserPrototypeDeletePushSubscriptionRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteReferrerRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteReferrerAccessTokensRequest {
  id: string;
  nk: string;
}

export interface CourierUserPrototypeDeleteReferrerReferrerRequest {
  id: string;
  nk: string;
}

export interface CourierUserPrototypeDeleteReferrerRoleMappingsRequest {
  id: string;
  nk: string;
}

export interface CourierUserPrototypeDeleteReferrerRolesRequest {
  id: string;
  nk: string;
}

export interface CourierUserPrototypeDeleteRoleMappingsRequest {
  id: string;
}

export interface CourierUserPrototypeDeleteRolesRequest {
  id: string;
}

export interface CourierUserPrototypeDestroyByIdAccessTokensRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdCourierPackagesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdInvoicesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdMailboxesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdPushSubscriptionRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdReferrerRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdReferrerAccessTokensRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdReferrerReferrerRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdRoleMappingsRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyByIdRolesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeDestroyRewardsAccountRequest {
  id: string;
}

export interface CourierUserPrototypeExistsReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeExistsRolesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdAccessTokensRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdCourierPackagesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdInvoicesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdMailboxesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdPushSubscriptionRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdReferrerRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdReferrerAccessTokensRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdReferrerReferrerRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdRoleMappingsRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeFindByIdRolesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeGetAccessTokensRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetCourierPackagesRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetCourierPackagesCourierRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetCourierPackagesOwnerRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetInvoicesRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetInvoicesBusinessRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetInvoicesCourierPackageRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetInvoicesCustomerRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetMailboxesRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetMailboxesCourierRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetMailboxesOwnerRequest {
  id: string;
  nk: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetPushSubscriptionRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetReferrerRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetReferrerAccessTokensRequest {
  id: string;
  nk: string;
  filter?: string;
}

export interface CourierUserPrototypeGetReferrerReferrerRequest {
  id: string;
  nk: string;
  filter?: string;
}

export interface CourierUserPrototypeGetReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  filter?: string;
}

export interface CourierUserPrototypeGetReferrerRolesRequest {
  id: string;
  nk: string;
  filter?: string;
}

export interface CourierUserPrototypeGetRewardsAccountRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeGetRoleMappingsRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetRolesRequest {
  id: string;
  filter?: string;
}

export interface CourierUserPrototypeGetStoreLocationRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierUserPrototypeLinkReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierUserPrototypeLinkRolesRequest {
  id: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierUserPrototypePatchAttributesRequest {
  id: string;
  data?: CourierUser;
}

export interface CourierUserPrototypeUnlinkReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
}

export interface CourierUserPrototypeUnlinkRolesRequest {
  id: string;
  fk: string;
}

export interface CourierUserPrototypeUpdateByIdAccessTokensRequest {
  id: string;
  fk: string;
  data?: AccessToken;
}

export interface CourierUserPrototypeUpdateByIdCourierPackagesRequest {
  id: string;
  fk: string;
  data?: CourierPackage;
}

export interface CourierUserPrototypeUpdateByIdInvoicesRequest {
  id: string;
  fk: string;
  data?: Invoice;
}

export interface CourierUserPrototypeUpdateByIdMailboxesRequest {
  id: string;
  fk: string;
  data?: Mailbox;
}

export interface CourierUserPrototypeUpdateByIdPushSubscriptionRequest {
  id: string;
  fk: string;
  data?: PushSubscription;
}

export interface CourierUserPrototypeUpdateByIdReferrerRequest {
  id: string;
  fk: string;
  data?: CourierUser;
}

export interface CourierUserPrototypeUpdateByIdReferrerAccessTokensRequest {
  id: string;
  nk: string;
  fk: string;
  data?: AccessToken;
}

export interface CourierUserPrototypeUpdateByIdReferrerReferrerRequest {
  id: string;
  nk: string;
  fk: string;
  data?: CourierUser;
}

export interface CourierUserPrototypeUpdateByIdReferrerRoleMappingsRequest {
  id: string;
  nk: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierUserPrototypeUpdateByIdReferrerRolesRequest {
  id: string;
  nk: string;
  fk: string;
  data?: Role;
}

export interface CourierUserPrototypeUpdateByIdRoleMappingsRequest {
  id: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierUserPrototypeUpdateByIdRolesRequest {
  id: string;
  fk: string;
  data?: Role;
}

export interface CourierUserPrototypeUpdateRewardsAccountRequest {
  id: string;
  data?: RewardsAccount;
}

export interface CourierUserPrototypeVerifyRequest {
  id: string;
}

export interface CourierUserReplaceByIdPostCourierUsersidReplaceRequest {
  id: string;
  data?: CourierUser;
}

export interface CourierUserReplaceByIdPutCourierUsersidRequest {
  id: string;
  data?: CourierUser;
}

export interface CourierUserReplaceOrCreatePostCourierUsersReplaceOrCreateRequest {
  data?: CourierUser;
}

export interface CourierUserReplaceOrCreatePutCourierUsersRequest {
  data?: CourierUser;
}

export interface CourierUserResetPasswordRequest {
  options: object;
}

export interface CourierUserSetPasswordOperationRequest {
  courierUserSetPasswordRequest: CourierUserSetPasswordRequest;
}

export interface CourierUserUpdateAllRequest {
  where?: string;
  data?: CourierUser;
}

export interface CourierUserUpsertWithWhereRequest {
  where?: string;
  data?: CourierUser;
}

export interface CourierUserAddAllUsersToShipCorpRequest {
  courierId: string;
}

export interface CourierUserAddAllUsersToLogisRequest {
  courierId: string;
}

export interface CourierUserAddAllUsersToCargoJaRequest {
  courierId: string;
}

export interface CourierUserAddAllUsersToFarin2YaadRequest {
  courierId: string;
}

export interface CourierUserAddAllUsersToAtoraRequest {
  courierId: string;
}

export interface CourierUserAddAllUsersToTrGlobalRequest {
  courierId: string;
}

/**
 * Result of a TR Global customer registration run.
 *
 * `partial` means the run hit its wall-clock budget and stopped cleanly — the
 * watermark advanced only as far as it got, so calling again resumes.
 */
export interface TrGlobalCustomerSyncResult {
  success: boolean;
  synced: number;
  failed: number;
  skipped: number;
  partial: boolean;
  message?: string;
}

export interface VerifyCodeRequest {
  code: string;
  userId: string;
  method: 'email' | 'whatsapp';
}

export interface CourierUserRequestWhatsAppVerificationRequest {
  realm: string;
  phoneNumber: string;
}

export interface CourierUserRequestWhatsAppVerificationResponse {
  success: boolean;
  message: string;
  userId: number;
  phoneNumber: string;
}

export interface CourierUserLoginWithWhatsAppCodeRequest {
  realm: string;
  code: string;
  userId: string;
}

export interface WhatsAppLoginAccessToken {
  id: string;
  ttl: number;
  created: string;
  userId: number;
}

export interface CourierUserLoginWithWhatsAppCodeResponse {
  success: boolean;
  message: string;
  accessToken: WhatsAppLoginAccessToken;
  user: Partial<CourierUser>;
}

export interface CourierUserRequestSmsVerificationRequest {
  realm: string;
  phoneNumber: string;
}

export interface CourierUserRequestSmsVerificationResponse {
  success: boolean;
  message: string;
  userId: number;
  phoneNumber: string;
}

export interface CourierUserLoginWithSmsCodeRequest {
  realm: string;
  code: string;
  userId: string;
}

export interface SmsLoginAccessToken {
  id: string;
  ttl: number;
  created: string;
  userId: number;
}

export interface CourierUserLoginWithSmsCodeResponse {
  success: boolean;
  message: string;
  accessToken: SmsLoginAccessToken;
  user: Partial<CourierUser>;
}

export interface CourierUserLoginWithAppleRequest {
  appleCredentials: {
    identityToken: string;
    authorizationCode: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    realm: string;
  };
}

export interface CourierUserLoginWithAppleResponse {
  success: boolean;
  message: string;
  id?: string;
  ttl?: number;
  created?: string;
  userId?: number;
  user?: Partial<CourierUser>;
}

/**
 * Passkeys (WebAuthn).
 *
 * The option and credential payloads are passed through untyped: they are
 * produced and consumed by @simplewebauthn/browser on the client and
 * @simplewebauthn/server on the API, and re-declaring their shapes here would
 * only create a third definition to keep in sync. Callers hand them straight
 * to startRegistration() / startAuthentication().
 */
export type PasskeyPublicKeyOptions = Record<string, any>;
export type PasskeyCredentialResponse = Record<string, any>;

export interface CourierUserPasskeyOptionsResponse {
  options: PasskeyPublicKeyOptions;
}

export interface CourierUserPasskeyRegisterVerifyRequest {
  credential: PasskeyCredentialResponse;
  name?: string;
}

export interface CourierUserPasskeyRegisterVerifyResponse {
  success: boolean;
  credential: PasskeyCredential;
}

export interface CourierUserPasskeyLoginOptionsRequest {
  realm: string;
  /** Omit for a discoverable sign-in — the browser then shows its own account picker. */
  email?: string;
}

export interface CourierUserPasskeyLoginVerifyRequest {
  realm: string;
  credential: PasskeyCredentialResponse;
}

/** Same flattened shape as the Apple login, so it drops straight into dispatch(login(...)). */
export interface CourierUserPasskeyLoginResponse {
  success: boolean;
  message: string;
  id?: string;
  ttl?: number;
  created?: string;
  userId?: number;
  user?: Partial<CourierUser>;
}

export interface CourierUserPasskeyListResponse {
  credentials: PasskeyCredential[];
}

export interface CourierUserPasskeyRenameRequest {
  credentialId: string;
  name: string;
}

export interface CourierUserPasskeyDeleteRequest {
  credentialId: string;
}

export interface CourierUserDeleteAccountRequest {
  id: string;
}

export interface CourierUserDeleteAccountResponse {
  success: boolean;
  message: string;
}

export interface CourierUserGetNextManifestNumberRequest {
  id: string;
}

export interface CourierUserGetNextManifestNumberResponse {
  manifestNumber: string;
  sequence: number;
}

/**
 *
 */
export class CourierUserApi extends runtime.BaseAPI {
  /**
   * Change a user\'s password.
   */
  async courierUserChangePasswordRaw(
    requestParameters: CourierUserChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['courierUserChangePasswordRequest'] == null) {
      throw new runtime.RequiredError(
        'courierUserChangePasswordRequest',
        'Required parameter "courierUserChangePasswordRequest" was null or undefined when calling courierUserChangePassword().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/change-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserChangePasswordRequestToJSON(
          requestParameters['courierUserChangePasswordRequest']
        ),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Change a user\'s password.
   */
  async courierUserChangePassword(
    requestParameters: CourierUserChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserChangePasswordRaw(requestParameters, initOverrides);
  }

  /**
   * Confirm a user registration with identity verification token.
   */
  async courierUserConfirmRaw(
    requestParameters: CourierUserConfirmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['uid'] == null) {
      throw new runtime.RequiredError(
        'uid',
        'Required parameter "uid" was null or undefined when calling courierUserConfirm().'
      );
    }

    if (requestParameters['token'] == null) {
      throw new runtime.RequiredError(
        'token',
        'Required parameter "token" was null or undefined when calling courierUserConfirm().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['uid'] != null) {
      queryParameters['uid'] = requestParameters['uid'];
    }

    if (requestParameters['token'] != null) {
      queryParameters['token'] = requestParameters['token'];
    }

    if (requestParameters['redirect'] != null) {
      queryParameters['redirect'] = requestParameters['redirect'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/confirm`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Confirm a user registration with identity verification token.
   */
  async courierUserConfirm(
    requestParameters: CourierUserConfirmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserConfirmRaw(requestParameters, initOverrides);
  }

  /**
   * Count instances of the model matched by where from the data source.
   */
  async courierUserCountRaw(
    requestParameters: CourierUserCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/count`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Count instances of the model matched by where from the data source.
   */
  async courierUserCount(
    requestParameters: CourierUserCountRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserCountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async courierUserCreateRaw(
    requestParameters: CourierUserCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async courierUserCreate(
    requestParameters: CourierUserCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Create a change stream.
   */
  async courierUserCreateChangeStreamGetCourierUsersChangeStreamRaw(
    requestParameters: CourierUserCreateChangeStreamGetCourierUsersChangeStreamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    if (requestParameters['options'] != null) {
      queryParameters['options'] = requestParameters['options'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/change-stream`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Create a change stream.
   */
  async courierUserCreateChangeStreamGetCourierUsersChangeStream(
    requestParameters: CourierUserCreateChangeStreamGetCourierUsersChangeStreamRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response =
      await this.courierUserCreateChangeStreamGetCourierUsersChangeStreamRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Create a change stream.
   */
  async courierUserCreateChangeStreamPostCourierUsersChangeStreamRaw(
    requestParameters: CourierUserCreateChangeStreamPostCourierUsersChangeStreamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/change-stream`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(
          requestParameters[
            'roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest'
          ]
        ),
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Create a change stream.
   */
  async courierUserCreateChangeStreamPostCourierUsersChangeStream(
    requestParameters: CourierUserCreateChangeStreamPostCourierUsersChangeStreamRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response =
      await this.courierUserCreateChangeStreamPostCourierUsersChangeStreamRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   */
  async courierUserCreateUserWithTempPasswordRaw(
    requestParameters: CourierUserCreateUserWithTempPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['userObject'] == null) {
      throw new runtime.RequiredError(
        'userObject',
        'Required parameter "userObject" was null or undefined when calling courierUserCreateUserWithTempPassword().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/createUserWithTempPassword`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['userObject'] as any,
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierUserCreateUserWithTempPassword(
    requestParameters: CourierUserCreateUserWithTempPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserCreateUserWithTempPasswordRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserCreateWhatsAppUserRaw(
    requestParameters: CourierUserCreateWhatsAppUserOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/createWhatsAppUser`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserCreateWhatsAppUserRequestToJSON(
          requestParameters['courierUserCreateWhatsAppUserRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierUserCreateWhatsAppUser(
    requestParameters: CourierUserCreateWhatsAppUserOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.courierUserCreateWhatsAppUserRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async courierUserDeleteByIdRaw(
    requestParameters: CourierUserDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserDeleteById().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async courierUserDeleteById(
    requestParameters: CourierUserDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierUserDeleteByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierUserExistsGetCourierUsersidExistsRaw(
    requestParameters: CourierUserExistsGetCourierUsersidExistsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>
  > {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserExistsGetCourierUsersidExists().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/exists`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierUserExistsGetCourierUsersidExists(
    requestParameters: CourierUserExistsGetCourierUsersidExistsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
    const response = await this.courierUserExistsGetCourierUsersidExistsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierUserExistsHeadCourierUsersidRaw(
    requestParameters: CourierUserExistsHeadCourierUsersidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>
  > {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserExistsHeadCourierUsersid().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'HEAD',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierUserExistsHeadCourierUsersid(
    requestParameters: CourierUserExistsHeadCourierUsersidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
    const response = await this.courierUserExistsHeadCourierUsersidRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserExportUsersRaw(
    requestParameters: CourierUserExportUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserExportUsers().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/export-users/{realm}`.replace(
          `{${'realm'}}`,
          encodeURIComponent(String(requestParameters['realm']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async courierUserExportUsers(
    requestParameters: CourierUserExportUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserExportUsersRaw(requestParameters, initOverrides);
  }

  /**
   */
  async courierUserExportUsersForQuickBooksRaw(
    requestParameters: CourierUserExportUsersForQuickBooksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserExportUsersForQuickBooks().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/export-users-quickbooks/{realm}`.replace(
          `{${'realm'}}`,
          encodeURIComponent(String(requestParameters['realm']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async courierUserExportUsersForQuickBooks(
    requestParameters: CourierUserExportUsersForQuickBooksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserExportUsersForQuickBooksRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async courierUserFindRaw(
    requestParameters: CourierUserFindRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierUser>>> {
    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierUserFromJSON)
    );
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async courierUserFind(
    requestParameters: CourierUserFindRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierUser>> {
    const response = await this.courierUserFindRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async courierUserFindByIdRaw(
    requestParameters: CourierUserFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserFindById().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async courierUserFindById(
    requestParameters: CourierUserFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserFindByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   */
  async courierUserFindOneRaw(
    requestParameters: CourierUserFindOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/findOne`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   */
  async courierUserFindOne(
    requestParameters: CourierUserFindOneRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserFindOneRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserGetAdministratorsRaw(
    requestParameters: CourierUserGetAdministratorsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierUser>>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserGetAdministrators().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/administrators/{realm}`.replace(
          `{${'realm'}}`,
          encodeURIComponent(String(requestParameters['realm']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierUserFromJSON)
    );
  }

  /**
   */
  async courierUserGetAdministrators(
    requestParameters: CourierUserGetAdministratorsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierUser>> {
    const response = await this.courierUserGetAdministratorsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Resolve a referral code (user id) or name/email to an existing referrer
   * within a realm. Used during signup to link a new customer to their referrer.
   */
  async courierUserResolveReferrerRaw(
    requestParameters: CourierUserResolveReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResolvedReferrer | null>> {
    if (requestParameters['query'] == null) {
      throw new runtime.RequiredError(
        'query',
        'Required parameter "query" was null or undefined when calling courierUserResolveReferrer().'
      );
    }
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserResolveReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['query'] != null) {
      queryParameters['query'] = requestParameters['query'];
    }

    if (requestParameters['realm'] != null) {
      queryParameters['realm'] = requestParameters['realm'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/resolve-referrer`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
  }

  /**
   * Resolve a referral code (user id) or name/email to an existing referrer.
   */
  async courierUserResolveReferrer(
    requestParameters: CourierUserResolveReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResolvedReferrer | null> {
    const response = await this.courierUserResolveReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserGetUserIdByEmailRaw(
    requestParameters: CourierUserGetUserIdByEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/getUserIdByEmail`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserGetUserIdByEmailRequestToJSON(
          requestParameters['courierUserGetUserIdByEmailRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierUserGetUserIdByEmail(
    requestParameters: CourierUserGetUserIdByEmailOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.courierUserGetUserIdByEmailRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserImportFromCsvRaw(
    requestParameters: CourierUserImportFromCsvOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/importFromCsv`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserImportFromCsvRequestToJSON(
          requestParameters['courierUserImportFromCsvRequest']
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async courierUserImportFromCsv(
    requestParameters: CourierUserImportFromCsvOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierUserImportFromCsvRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierUserImportUsersFromJsonRaw(
    requestParameters: CourierUserImportUsersFromJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['data'] == null) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter "data" was null or undefined when calling courierUserImportUsersFromJson().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/import-users-from-json`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async courierUserImportUsersFromJson(
    requestParameters: CourierUserImportUsersFromJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierUserImportUsersFromJsonRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Login a user with username/email and password.
   */
  async courierUserLoginRaw(
    requestParameters: CourierUserLoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['credentials'] == null) {
      throw new runtime.RequiredError(
        'credentials',
        'Required parameter "credentials" was null or undefined when calling courierUserLogin().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['include'] != null) {
      queryParameters['include'] = requestParameters['include'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['credentials'] as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Login a user with username/email and password.
   */
  async courierUserLogin(
    requestParameters: CourierUserLoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierUserLoginRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Logout a user with access token.
   */
  async courierUserLogoutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/logout`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Logout a user with access token.
   */
  async courierUserLogout(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserLogoutRaw(initOverrides);
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   */
  async courierUserPatchOrCreateRaw(
    requestParameters: CourierUserPatchOrCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   */
  async courierUserPatchOrCreate(
    requestParameters: CourierUserPatchOrCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPatchOrCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierUserPrototypeCountAccessTokensRaw(
    requestParameters: CourierUserPrototypeCountAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierUserPrototypeCountAccessTokens(
    requestParameters: CourierUserPrototypeCountAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts courierPackages of CourierUser.
   */
  async courierUserPrototypeCountCourierPackagesRaw(
    requestParameters: CourierUserPrototypeCountCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountCourierPackages().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts courierPackages of CourierUser.
   */
  async courierUserPrototypeCountCourierPackages(
    requestParameters: CourierUserPrototypeCountCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts invoices of CourierUser.
   */
  async courierUserPrototypeCountInvoicesRaw(
    requestParameters: CourierUserPrototypeCountInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountInvoices().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts invoices of CourierUser.
   */
  async courierUserPrototypeCountInvoices(
    requestParameters: CourierUserPrototypeCountInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountInvoicesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts mailboxes of CourierUser.
   */
  async courierUserPrototypeCountMailboxesRaw(
    requestParameters: CourierUserPrototypeCountMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountMailboxes().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts mailboxes of CourierUser.
   */
  async courierUserPrototypeCountMailboxes(
    requestParameters: CourierUserPrototypeCountMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountMailboxesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts pushSubscription of CourierUser.
   */
  async courierUserPrototypeCountPushSubscriptionRaw(
    requestParameters: CourierUserPrototypeCountPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountPushSubscription().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts pushSubscription of CourierUser.
   */
  async courierUserPrototypeCountPushSubscription(
    requestParameters: CourierUserPrototypeCountPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountPushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierUserPrototypeCountReferrerRaw(
    requestParameters: CourierUserPrototypeCountReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierUserPrototypeCountReferrer(
    requestParameters: CourierUserPrototypeCountReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierUserPrototypeCountReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeCountReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCountReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens/count`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierUserPrototypeCountReferrerAccessTokens(
    requestParameters: CourierUserPrototypeCountReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response =
      await this.courierUserPrototypeCountReferrerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierUserPrototypeCountReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeCountReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCountReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer/count`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierUserPrototypeCountReferrerReferrer(
    requestParameters: CourierUserPrototypeCountReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierUserPrototypeCountReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeCountReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCountReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings/count`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierUserPrototypeCountReferrerRoleMappings(
    requestParameters: CourierUserPrototypeCountReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response =
      await this.courierUserPrototypeCountReferrerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierUserPrototypeCountReferrerRolesRaw(
    requestParameters: CourierUserPrototypeCountReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCountReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/count`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierUserPrototypeCountReferrerRoles(
    requestParameters: CourierUserPrototypeCountReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierUserPrototypeCountRoleMappingsRaw(
    requestParameters: CourierUserPrototypeCountRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierUserPrototypeCountRoleMappings(
    requestParameters: CourierUserPrototypeCountRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierUserPrototypeCountRolesRaw(
    requestParameters: CourierUserPrototypeCountRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCountRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierUserPrototypeCountRoles(
    requestParameters: CourierUserPrototypeCountRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierUserPrototypeCountRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierUserPrototypeCreateAccessTokensRaw(
    requestParameters: CourierUserPrototypeCreateAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierUserPrototypeCreateAccessTokens(
    requestParameters: CourierUserPrototypeCreateAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response = await this.courierUserPrototypeCreateAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in courierPackages of this model.
   */
  async courierUserPrototypeCreateCourierPackagesRaw(
    requestParameters: CourierUserPrototypeCreateCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in courierPackages of this model.
   */
  async courierUserPrototypeCreateCourierPackages(
    requestParameters: CourierUserPrototypeCreateCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierUserPrototypeCreateCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in invoices of this model.
   */
  async courierUserPrototypeCreateInvoicesRaw(
    requestParameters: CourierUserPrototypeCreateInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateInvoices().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewInvoiceToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in invoices of this model.
   */
  async courierUserPrototypeCreateInvoices(
    requestParameters: CourierUserPrototypeCreateInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierUserPrototypeCreateInvoicesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in mailboxes of this model.
   */
  async courierUserPrototypeCreateMailboxesRaw(
    requestParameters: CourierUserPrototypeCreateMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Mailbox>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateMailboxes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewMailboxToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MailboxFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in mailboxes of this model.
   */
  async courierUserPrototypeCreateMailboxes(
    requestParameters: CourierUserPrototypeCreateMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Mailbox> {
    const response = await this.courierUserPrototypeCreateMailboxesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in pushSubscription of this model.
   */
  async courierUserPrototypeCreatePushSubscriptionRaw(
    requestParameters: CourierUserPrototypeCreatePushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PushSubscription>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreatePushSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewPushSubscriptionToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PushSubscriptionFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in pushSubscription of this model.
   */
  async courierUserPrototypeCreatePushSubscription(
    requestParameters: CourierUserPrototypeCreatePushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PushSubscription> {
    const response = await this.courierUserPrototypeCreatePushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierUserPrototypeCreateReferrerRaw(
    requestParameters: CourierUserPrototypeCreateReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierUserPrototypeCreateReferrer(
    requestParameters: CourierUserPrototypeCreateReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeCreateReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierUserPrototypeCreateReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeCreateReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCreateReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierUserPrototypeCreateReferrerAccessTokens(
    requestParameters: CourierUserPrototypeCreateReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierUserPrototypeCreateReferrerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierUserPrototypeCreateReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeCreateReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCreateReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierUserPrototypeCreateReferrerReferrer(
    requestParameters: CourierUserPrototypeCreateReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeCreateReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierUserPrototypeCreateReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeCreateReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCreateReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierUserPrototypeCreateReferrerRoleMappings(
    requestParameters: CourierUserPrototypeCreateReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierUserPrototypeCreateReferrerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierUserPrototypeCreateReferrerRolesRaw(
    requestParameters: CourierUserPrototypeCreateReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeCreateReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierUserPrototypeCreateReferrerRoles(
    requestParameters: CourierUserPrototypeCreateReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeCreateReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in rewardsAccount of this model.
   */
  async courierUserPrototypeCreateRewardsAccountRaw(
    requestParameters: CourierUserPrototypeCreateRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RewardsAccount>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateRewardsAccount().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/rewardsAccount`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RewardsAccountToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RewardsAccountFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in rewardsAccount of this model.
   */
  async courierUserPrototypeCreateRewardsAccount(
    requestParameters: CourierUserPrototypeCreateRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RewardsAccount> {
    const response = await this.courierUserPrototypeCreateRewardsAccountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierUserPrototypeCreateRoleMappingsRaw(
    requestParameters: CourierUserPrototypeCreateRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierUserPrototypeCreateRoleMappings(
    requestParameters: CourierUserPrototypeCreateRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierUserPrototypeCreateRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierUserPrototypeCreateRolesRaw(
    requestParameters: CourierUserPrototypeCreateRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeCreateRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierUserPrototypeCreateRoles(
    requestParameters: CourierUserPrototypeCreateRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeCreateRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierUserPrototypeDeleteAccessTokensRaw(
    requestParameters: CourierUserPrototypeDeleteAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierUserPrototypeDeleteAccessTokens(
    requestParameters: CourierUserPrototypeDeleteAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all courierPackages of this model.
   */
  async courierUserPrototypeDeleteCourierPackagesRaw(
    requestParameters: CourierUserPrototypeDeleteCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all courierPackages of this model.
   */
  async courierUserPrototypeDeleteCourierPackages(
    requestParameters: CourierUserPrototypeDeleteCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all invoices of this model.
   */
  async courierUserPrototypeDeleteInvoicesRaw(
    requestParameters: CourierUserPrototypeDeleteInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteInvoices().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all invoices of this model.
   */
  async courierUserPrototypeDeleteInvoices(
    requestParameters: CourierUserPrototypeDeleteInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteInvoicesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all mailboxes of this model.
   */
  async courierUserPrototypeDeleteMailboxesRaw(
    requestParameters: CourierUserPrototypeDeleteMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteMailboxes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all mailboxes of this model.
   */
  async courierUserPrototypeDeleteMailboxes(
    requestParameters: CourierUserPrototypeDeleteMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteMailboxesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all pushSubscription of this model.
   */
  async courierUserPrototypeDeletePushSubscriptionRaw(
    requestParameters: CourierUserPrototypeDeletePushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeletePushSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all pushSubscription of this model.
   */
  async courierUserPrototypeDeletePushSubscription(
    requestParameters: CourierUserPrototypeDeletePushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeletePushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierUserPrototypeDeleteReferrerRaw(
    requestParameters: CourierUserPrototypeDeleteReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierUserPrototypeDeleteReferrer(
    requestParameters: CourierUserPrototypeDeleteReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierUserPrototypeDeleteReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeDeleteReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDeleteReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierUserPrototypeDeleteReferrerAccessTokens(
    requestParameters: CourierUserPrototypeDeleteReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteReferrerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierUserPrototypeDeleteReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeDeleteReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDeleteReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierUserPrototypeDeleteReferrerReferrer(
    requestParameters: CourierUserPrototypeDeleteReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all roleMappings of this model.
   */
  async courierUserPrototypeDeleteReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeDeleteReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDeleteReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all roleMappings of this model.
   */
  async courierUserPrototypeDeleteReferrerRoleMappings(
    requestParameters: CourierUserPrototypeDeleteReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteReferrerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all roles of this model.
   */
  async courierUserPrototypeDeleteReferrerRolesRaw(
    requestParameters: CourierUserPrototypeDeleteReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDeleteReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDeleteReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all roles of this model.
   */
  async courierUserPrototypeDeleteReferrerRoles(
    requestParameters: CourierUserPrototypeDeleteReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDeleteReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierUserPrototypeDestroyByIdAccessTokensRaw(
    requestParameters: CourierUserPrototypeDestroyByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierUserPrototypeDestroyByIdAccessTokens(
    requestParameters: CourierUserPrototypeDestroyByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for courierPackages.
   */
  async courierUserPrototypeDestroyByIdCourierPackagesRaw(
    requestParameters: CourierUserPrototypeDestroyByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for courierPackages.
   */
  async courierUserPrototypeDestroyByIdCourierPackages(
    requestParameters: CourierUserPrototypeDestroyByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for invoices.
   */
  async courierUserPrototypeDestroyByIdInvoicesRaw(
    requestParameters: CourierUserPrototypeDestroyByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdInvoices().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdInvoices().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for invoices.
   */
  async courierUserPrototypeDestroyByIdInvoices(
    requestParameters: CourierUserPrototypeDestroyByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdInvoicesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for mailboxes.
   */
  async courierUserPrototypeDestroyByIdMailboxesRaw(
    requestParameters: CourierUserPrototypeDestroyByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdMailboxes().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdMailboxes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for mailboxes.
   */
  async courierUserPrototypeDestroyByIdMailboxes(
    requestParameters: CourierUserPrototypeDestroyByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdMailboxesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for pushSubscription.
   */
  async courierUserPrototypeDestroyByIdPushSubscriptionRaw(
    requestParameters: CourierUserPrototypeDestroyByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdPushSubscription().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdPushSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for pushSubscription.
   */
  async courierUserPrototypeDestroyByIdPushSubscription(
    requestParameters: CourierUserPrototypeDestroyByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdPushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierUserPrototypeDestroyByIdReferrerRaw(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierUserPrototypeDestroyByIdReferrer(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierUserPrototypeDestroyByIdReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierUserPrototypeDestroyByIdReferrerAccessTokens(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdReferrerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierUserPrototypeDestroyByIdReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierUserPrototypeDestroyByIdReferrerReferrer(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierUserPrototypeDestroyByIdReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierUserPrototypeDestroyByIdReferrerRoleMappings(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdReferrerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierUserPrototypeDestroyByIdReferrerRolesRaw(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierUserPrototypeDestroyByIdReferrerRoles(
    requestParameters: CourierUserPrototypeDestroyByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierUserPrototypeDestroyByIdRoleMappingsRaw(
    requestParameters: CourierUserPrototypeDestroyByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierUserPrototypeDestroyByIdRoleMappings(
    requestParameters: CourierUserPrototypeDestroyByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierUserPrototypeDestroyByIdRolesRaw(
    requestParameters: CourierUserPrototypeDestroyByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyByIdRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeDestroyByIdRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierUserPrototypeDestroyByIdRoles(
    requestParameters: CourierUserPrototypeDestroyByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyByIdRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes rewardsAccount of this model.
   */
  async courierUserPrototypeDestroyRewardsAccountRaw(
    requestParameters: CourierUserPrototypeDestroyRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeDestroyRewardsAccount().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/rewardsAccount`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes rewardsAccount of this model.
   */
  async courierUserPrototypeDestroyRewardsAccount(
    requestParameters: CourierUserPrototypeDestroyRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeDestroyRewardsAccountRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierUserPrototypeExistsReferrerRolesRaw(
    requestParameters: CourierUserPrototypeExistsReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeExistsReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeExistsReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeExistsReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'HEAD',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierUserPrototypeExistsReferrerRoles(
    requestParameters: CourierUserPrototypeExistsReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserPrototypeExistsReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierUserPrototypeExistsRolesRaw(
    requestParameters: CourierUserPrototypeExistsRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeExistsRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeExistsRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'HEAD',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierUserPrototypeExistsRoles(
    requestParameters: CourierUserPrototypeExistsRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserPrototypeExistsRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierUserPrototypeFindByIdAccessTokensRaw(
    requestParameters: CourierUserPrototypeFindByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierUserPrototypeFindByIdAccessTokens(
    requestParameters: CourierUserPrototypeFindByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response = await this.courierUserPrototypeFindByIdAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for courierPackages.
   */
  async courierUserPrototypeFindByIdCourierPackagesRaw(
    requestParameters: CourierUserPrototypeFindByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for courierPackages.
   */
  async courierUserPrototypeFindByIdCourierPackages(
    requestParameters: CourierUserPrototypeFindByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierUserPrototypeFindByIdCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for invoices.
   */
  async courierUserPrototypeFindByIdInvoicesRaw(
    requestParameters: CourierUserPrototypeFindByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdInvoices().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdInvoices().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for invoices.
   */
  async courierUserPrototypeFindByIdInvoices(
    requestParameters: CourierUserPrototypeFindByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierUserPrototypeFindByIdInvoicesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for mailboxes.
   */
  async courierUserPrototypeFindByIdMailboxesRaw(
    requestParameters: CourierUserPrototypeFindByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Mailbox>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdMailboxes().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdMailboxes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MailboxFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for mailboxes.
   */
  async courierUserPrototypeFindByIdMailboxes(
    requestParameters: CourierUserPrototypeFindByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Mailbox> {
    const response = await this.courierUserPrototypeFindByIdMailboxesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for pushSubscription.
   */
  async courierUserPrototypeFindByIdPushSubscriptionRaw(
    requestParameters: CourierUserPrototypeFindByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PushSubscription>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdPushSubscription().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdPushSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PushSubscriptionFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for pushSubscription.
   */
  async courierUserPrototypeFindByIdPushSubscription(
    requestParameters: CourierUserPrototypeFindByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PushSubscription> {
    const response = await this.courierUserPrototypeFindByIdPushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierUserPrototypeFindByIdReferrerRaw(
    requestParameters: CourierUserPrototypeFindByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierUserPrototypeFindByIdReferrer(
    requestParameters: CourierUserPrototypeFindByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeFindByIdReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierUserPrototypeFindByIdReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeFindByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeFindByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierUserPrototypeFindByIdReferrerAccessTokens(
    requestParameters: CourierUserPrototypeFindByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierUserPrototypeFindByIdReferrerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierUserPrototypeFindByIdReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeFindByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeFindByIdReferrerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierUserPrototypeFindByIdReferrerReferrer(
    requestParameters: CourierUserPrototypeFindByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeFindByIdReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierUserPrototypeFindByIdReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeFindByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierUserPrototypeFindByIdReferrerRoleMappings(
    requestParameters: CourierUserPrototypeFindByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierUserPrototypeFindByIdReferrerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Find a related item by id for roles.
   */
  async courierUserPrototypeFindByIdReferrerRolesRaw(
    requestParameters: CourierUserPrototypeFindByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roles.
   */
  async courierUserPrototypeFindByIdReferrerRoles(
    requestParameters: CourierUserPrototypeFindByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeFindByIdReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierUserPrototypeFindByIdRoleMappingsRaw(
    requestParameters: CourierUserPrototypeFindByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierUserPrototypeFindByIdRoleMappings(
    requestParameters: CourierUserPrototypeFindByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierUserPrototypeFindByIdRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for roles.
   */
  async courierUserPrototypeFindByIdRolesRaw(
    requestParameters: CourierUserPrototypeFindByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeFindByIdRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeFindByIdRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roles.
   */
  async courierUserPrototypeFindByIdRoles(
    requestParameters: CourierUserPrototypeFindByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeFindByIdRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierUserPrototypeGetAccessTokensRaw(
    requestParameters: CourierUserPrototypeGetAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<AccessToken>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AccessTokenFromJSON)
    );
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierUserPrototypeGetAccessTokens(
    requestParameters: CourierUserPrototypeGetAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<AccessToken>> {
    const response = await this.courierUserPrototypeGetAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries courierPackages of CourierUser.
   */
  async courierUserPrototypeGetCourierPackagesRaw(
    requestParameters: CourierUserPrototypeGetCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetCourierPackages().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierPackageFromJSON)
    );
  }

  /**
   * Queries courierPackages of CourierUser.
   */
  async courierUserPrototypeGetCourierPackages(
    requestParameters: CourierUserPrototypeGetCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierPackage>> {
    const response = await this.courierUserPrototypeGetCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierUserPrototypeGetCourierPackagesCourierRaw(
    requestParameters: CourierUserPrototypeGetCourierPackagesCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Courier>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetCourierPackagesCourier().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetCourierPackagesCourier().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/{nk}/courier`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierUserPrototypeGetCourierPackagesCourier(
    requestParameters: CourierUserPrototypeGetCourierPackagesCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Courier> {
    const response =
      await this.courierUserPrototypeGetCourierPackagesCourierRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierUserPrototypeGetCourierPackagesOwnerRaw(
    requestParameters: CourierUserPrototypeGetCourierPackagesOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetCourierPackagesOwner().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetCourierPackagesOwner().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/{nk}/owner`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierUserPrototypeGetCourierPackagesOwner(
    requestParameters: CourierUserPrototypeGetCourierPackagesOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeGetCourierPackagesOwnerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries invoices of CourierUser.
   */
  async courierUserPrototypeGetInvoicesRaw(
    requestParameters: CourierUserPrototypeGetInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Invoice>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetInvoices().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(InvoiceFromJSON)
    );
  }

  /**
   * Queries invoices of CourierUser.
   */
  async courierUserPrototypeGetInvoices(
    requestParameters: CourierUserPrototypeGetInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Invoice>> {
    const response = await this.courierUserPrototypeGetInvoicesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation business.
   */
  async courierUserPrototypeGetInvoicesBusinessRaw(
    requestParameters: CourierUserPrototypeGetInvoicesBusinessRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Courier>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetInvoicesBusiness().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetInvoicesBusiness().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{nk}/business`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation business.
   */
  async courierUserPrototypeGetInvoicesBusiness(
    requestParameters: CourierUserPrototypeGetInvoicesBusinessRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Courier> {
    const response = await this.courierUserPrototypeGetInvoicesBusinessRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation courierPackage.
   */
  async courierUserPrototypeGetInvoicesCourierPackageRaw(
    requestParameters: CourierUserPrototypeGetInvoicesCourierPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetInvoicesCourierPackage().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetInvoicesCourierPackage().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{nk}/courierPackage`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation courierPackage.
   */
  async courierUserPrototypeGetInvoicesCourierPackage(
    requestParameters: CourierUserPrototypeGetInvoicesCourierPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierUserPrototypeGetInvoicesCourierPackageRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation customer.
   */
  async courierUserPrototypeGetInvoicesCustomerRaw(
    requestParameters: CourierUserPrototypeGetInvoicesCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetInvoicesCustomer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetInvoicesCustomer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{nk}/customer`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation customer.
   */
  async courierUserPrototypeGetInvoicesCustomer(
    requestParameters: CourierUserPrototypeGetInvoicesCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeGetInvoicesCustomerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries mailboxes of CourierUser.
   */
  async courierUserPrototypeGetMailboxesRaw(
    requestParameters: CourierUserPrototypeGetMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Mailbox>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetMailboxes().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(MailboxFromJSON)
    );
  }

  /**
   * Queries mailboxes of CourierUser.
   */
  async courierUserPrototypeGetMailboxes(
    requestParameters: CourierUserPrototypeGetMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Mailbox>> {
    const response = await this.courierUserPrototypeGetMailboxesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierUserPrototypeGetMailboxesCourierRaw(
    requestParameters: CourierUserPrototypeGetMailboxesCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Courier>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetMailboxesCourier().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetMailboxesCourier().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/{nk}/courier`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierUserPrototypeGetMailboxesCourier(
    requestParameters: CourierUserPrototypeGetMailboxesCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Courier> {
    const response = await this.courierUserPrototypeGetMailboxesCourierRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierUserPrototypeGetMailboxesOwnerRaw(
    requestParameters: CourierUserPrototypeGetMailboxesOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetMailboxesOwner().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetMailboxesOwner().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/{nk}/owner`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierUserPrototypeGetMailboxesOwner(
    requestParameters: CourierUserPrototypeGetMailboxesOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeGetMailboxesOwnerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries pushSubscription of CourierUser.
   */
  async courierUserPrototypeGetPushSubscriptionRaw(
    requestParameters: CourierUserPrototypeGetPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<PushSubscription>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetPushSubscription().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PushSubscriptionFromJSON)
    );
  }

  /**
   * Queries pushSubscription of CourierUser.
   */
  async courierUserPrototypeGetPushSubscription(
    requestParameters: CourierUserPrototypeGetPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<PushSubscription>> {
    const response = await this.courierUserPrototypeGetPushSubscriptionRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierUserPrototypeGetReferrerRaw(
    requestParameters: CourierUserPrototypeGetReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierUser>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierUserFromJSON)
    );
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierUserPrototypeGetReferrer(
    requestParameters: CourierUserPrototypeGetReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierUser>> {
    const response = await this.courierUserPrototypeGetReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierUserPrototypeGetReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeGetReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<AccessToken>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AccessTokenFromJSON)
    );
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierUserPrototypeGetReferrerAccessTokens(
    requestParameters: CourierUserPrototypeGetReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<AccessToken>> {
    const response = await this.courierUserPrototypeGetReferrerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierUserPrototypeGetReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeGetReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierUser>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierUserFromJSON)
    );
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierUserPrototypeGetReferrerReferrer(
    requestParameters: CourierUserPrototypeGetReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierUser>> {
    const response = await this.courierUserPrototypeGetReferrerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierUserPrototypeGetReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeGetReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleMappingFromJSON)
    );
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierUserPrototypeGetReferrerRoleMappings(
    requestParameters: CourierUserPrototypeGetReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<RoleMapping>> {
    const response = await this.courierUserPrototypeGetReferrerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierUserPrototypeGetReferrerRolesRaw(
    requestParameters: CourierUserPrototypeGetReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Role>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeGetReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleFromJSON)
    );
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierUserPrototypeGetReferrerRoles(
    requestParameters: CourierUserPrototypeGetReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Role>> {
    const response = await this.courierUserPrototypeGetReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches hasOne relation rewardsAccount.
   */
  async courierUserPrototypeGetRewardsAccountRaw(
    requestParameters: CourierUserPrototypeGetRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RewardsAccount>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetRewardsAccount().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/rewardsAccount`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RewardsAccountFromJSON(jsonValue)
    );
  }

  /**
   * Fetches hasOne relation rewardsAccount.
   */
  async courierUserPrototypeGetRewardsAccount(
    requestParameters: CourierUserPrototypeGetRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RewardsAccount> {
    const response = await this.courierUserPrototypeGetRewardsAccountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierUserPrototypeGetRoleMappingsRaw(
    requestParameters: CourierUserPrototypeGetRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleMappingFromJSON)
    );
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierUserPrototypeGetRoleMappings(
    requestParameters: CourierUserPrototypeGetRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<RoleMapping>> {
    const response = await this.courierUserPrototypeGetRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierUserPrototypeGetRolesRaw(
    requestParameters: CourierUserPrototypeGetRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Role>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleFromJSON)
    );
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierUserPrototypeGetRoles(
    requestParameters: CourierUserPrototypeGetRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Role>> {
    const response = await this.courierUserPrototypeGetRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation storeLocation.
   */
  async courierUserPrototypeGetStoreLocationRaw(
    requestParameters: CourierUserPrototypeGetStoreLocationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StoreLocation>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeGetStoreLocation().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/storeLocation`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StoreLocationFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation storeLocation.
   */
  async courierUserPrototypeGetStoreLocation(
    requestParameters: CourierUserPrototypeGetStoreLocationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StoreLocation> {
    const response = await this.courierUserPrototypeGetStoreLocationRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add a related item by id for roles.
   */
  async courierUserPrototypeLinkReferrerRolesRaw(
    requestParameters: CourierUserPrototypeLinkReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeLinkReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeLinkReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeLinkReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Add a related item by id for roles.
   */
  async courierUserPrototypeLinkReferrerRoles(
    requestParameters: CourierUserPrototypeLinkReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierUserPrototypeLinkReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add a related item by id for roles.
   */
  async courierUserPrototypeLinkRolesRaw(
    requestParameters: CourierUserPrototypeLinkRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeLinkRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeLinkRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Add a related item by id for roles.
   */
  async courierUserPrototypeLinkRoles(
    requestParameters: CourierUserPrototypeLinkRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierUserPrototypeLinkRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async courierUserPrototypePatchAttributesRaw(
    requestParameters: CourierUserPrototypePatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypePatchAttributes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async courierUserPrototypePatchAttributes(
    requestParameters: CourierUserPrototypePatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypePatchAttributesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierUserPrototypeUnlinkReferrerRolesRaw(
    requestParameters: CourierUserPrototypeUnlinkReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUnlinkReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeUnlinkReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUnlinkReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierUserPrototypeUnlinkReferrerRoles(
    requestParameters: CourierUserPrototypeUnlinkReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeUnlinkReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierUserPrototypeUnlinkRolesRaw(
    requestParameters: CourierUserPrototypeUnlinkRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUnlinkRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUnlinkRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierUserPrototypeUnlinkRoles(
    requestParameters: CourierUserPrototypeUnlinkRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeUnlinkRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierUserPrototypeUpdateByIdAccessTokensRaw(
    requestParameters: CourierUserPrototypeUpdateByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierUserPrototypeUpdateByIdAccessTokens(
    requestParameters: CourierUserPrototypeUpdateByIdAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response = await this.courierUserPrototypeUpdateByIdAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for courierPackages.
   */
  async courierUserPrototypeUpdateByIdCourierPackagesRaw(
    requestParameters: CourierUserPrototypeUpdateByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for courierPackages.
   */
  async courierUserPrototypeUpdateByIdCourierPackages(
    requestParameters: CourierUserPrototypeUpdateByIdCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierUserPrototypeUpdateByIdCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for invoices.
   */
  async courierUserPrototypeUpdateByIdInvoicesRaw(
    requestParameters: CourierUserPrototypeUpdateByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdInvoices().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdInvoices().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/invoices/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: InvoiceToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for invoices.
   */
  async courierUserPrototypeUpdateByIdInvoices(
    requestParameters: CourierUserPrototypeUpdateByIdInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierUserPrototypeUpdateByIdInvoicesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for mailboxes.
   */
  async courierUserPrototypeUpdateByIdMailboxesRaw(
    requestParameters: CourierUserPrototypeUpdateByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Mailbox>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdMailboxes().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdMailboxes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/mailboxes/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: MailboxToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MailboxFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for mailboxes.
   */
  async courierUserPrototypeUpdateByIdMailboxes(
    requestParameters: CourierUserPrototypeUpdateByIdMailboxesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Mailbox> {
    const response = await this.courierUserPrototypeUpdateByIdMailboxesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for pushSubscription.
   */
  async courierUserPrototypeUpdateByIdPushSubscriptionRaw(
    requestParameters: CourierUserPrototypeUpdateByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PushSubscription>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdPushSubscription().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdPushSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/pushSubscription/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: PushSubscriptionToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PushSubscriptionFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for pushSubscription.
   */
  async courierUserPrototypeUpdateByIdPushSubscription(
    requestParameters: CourierUserPrototypeUpdateByIdPushSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PushSubscription> {
    const response =
      await this.courierUserPrototypeUpdateByIdPushSubscriptionRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierUserPrototypeUpdateByIdReferrerRaw(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierUserPrototypeUpdateByIdReferrer(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserPrototypeUpdateByIdReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierUserPrototypeUpdateByIdReferrerAccessTokensRaw(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierUserPrototypeUpdateByIdReferrerAccessTokens(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierUserPrototypeUpdateByIdReferrerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierUserPrototypeUpdateByIdReferrerReferrerRaw(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerReferrer().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierUserPrototypeUpdateByIdReferrerReferrer(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response =
      await this.courierUserPrototypeUpdateByIdReferrerReferrerRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierUserPrototypeUpdateByIdReferrerRoleMappingsRaw(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierUserPrototypeUpdateByIdReferrerRoleMappings(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierUserPrototypeUpdateByIdReferrerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for roles.
   */
  async courierUserPrototypeUpdateByIdReferrerRolesRaw(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoles().'
      );
    }

    if (requestParameters['nk'] == null) {
      throw new runtime.RequiredError(
        'nk',
        'Required parameter "nk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdReferrerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/referrer/{nk}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'nk'}}`,
            encodeURIComponent(String(requestParameters['nk']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roles.
   */
  async courierUserPrototypeUpdateByIdReferrerRoles(
    requestParameters: CourierUserPrototypeUpdateByIdReferrerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeUpdateByIdReferrerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierUserPrototypeUpdateByIdRoleMappingsRaw(
    requestParameters: CourierUserPrototypeUpdateByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierUserPrototypeUpdateByIdRoleMappings(
    requestParameters: CourierUserPrototypeUpdateByIdRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierUserPrototypeUpdateByIdRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update a related item by id for roles.
   */
  async courierUserPrototypeUpdateByIdRolesRaw(
    requestParameters: CourierUserPrototypeUpdateByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateByIdRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierUserPrototypeUpdateByIdRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roles.
   */
  async courierUserPrototypeUpdateByIdRoles(
    requestParameters: CourierUserPrototypeUpdateByIdRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierUserPrototypeUpdateByIdRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update rewardsAccount of this model.
   */
  async courierUserPrototypeUpdateRewardsAccountRaw(
    requestParameters: CourierUserPrototypeUpdateRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RewardsAccount>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeUpdateRewardsAccount().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/rewardsAccount`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RewardsAccountToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RewardsAccountFromJSON(jsonValue)
    );
  }

  /**
   * Update rewardsAccount of this model.
   */
  async courierUserPrototypeUpdateRewardsAccount(
    requestParameters: CourierUserPrototypeUpdateRewardsAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RewardsAccount> {
    const response = await this.courierUserPrototypeUpdateRewardsAccountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Trigger user\'s identity verification with configured verifyOptions
   */
  async courierUserPrototypeVerifyRaw(
    requestParameters: CourierUserPrototypeVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserPrototypeVerify().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/verify`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Trigger user\'s identity verification with configured verifyOptions
   */
  async courierUserPrototypeVerify(
    requestParameters: CourierUserPrototypeVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserPrototypeVerifyRaw(requestParameters, initOverrides);
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierUserReplaceByIdPostCourierUsersidReplaceRaw(
    requestParameters: CourierUserReplaceByIdPostCourierUsersidReplaceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserReplaceByIdPostCourierUsersidReplace().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/replace`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierUserReplaceByIdPostCourierUsersidReplace(
    requestParameters: CourierUserReplaceByIdPostCourierUsersidReplaceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response =
      await this.courierUserReplaceByIdPostCourierUsersidReplaceRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierUserReplaceByIdPutCourierUsersidRaw(
    requestParameters: CourierUserReplaceByIdPutCourierUsersidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserReplaceByIdPutCourierUsersid().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierUserReplaceByIdPutCourierUsersid(
    requestParameters: CourierUserReplaceByIdPutCourierUsersidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserReplaceByIdPutCourierUsersidRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierUserReplaceOrCreatePostCourierUsersReplaceOrCreateRaw(
    requestParameters: CourierUserReplaceOrCreatePostCourierUsersReplaceOrCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/replaceOrCreate`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierUserReplaceOrCreatePostCourierUsersReplaceOrCreate(
    requestParameters: CourierUserReplaceOrCreatePostCourierUsersReplaceOrCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response =
      await this.courierUserReplaceOrCreatePostCourierUsersReplaceOrCreateRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierUserReplaceOrCreatePutCourierUsersRaw(
    requestParameters: CourierUserReplaceOrCreatePutCourierUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierUserReplaceOrCreatePutCourierUsers(
    requestParameters: CourierUserReplaceOrCreatePutCourierUsersRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserReplaceOrCreatePutCourierUsersRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Reset password for a user with email.
   */
  async courierUserResetPasswordRaw(
    requestParameters: CourierUserResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['options'] == null) {
      throw new runtime.RequiredError(
        'options',
        'Required parameter "options" was null or undefined when calling courierUserResetPassword().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/reset`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['options'] as any,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Reset password for a user with email.
   */
  async courierUserResetPassword(
    requestParameters: CourierUserResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserResetPasswordRaw(requestParameters, initOverrides);
  }

  /**
   * Reset user\'s password via a password-reset token.
   */
  async courierUserSetPasswordRaw(
    requestParameters: CourierUserSetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['courierUserSetPasswordRequest'] == null) {
      throw new runtime.RequiredError(
        'courierUserSetPasswordRequest',
        'Required parameter "courierUserSetPasswordRequest" was null or undefined when calling courierUserSetPassword().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/reset-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserSetPasswordRequestToJSON(
          requestParameters['courierUserSetPasswordRequest']
        ),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Reset user\'s password via a password-reset token.
   */
  async courierUserSetPassword(
    requestParameters: CourierUserSetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierUserSetPasswordRaw(requestParameters, initOverrides);
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   */
  async courierUserUpdateAllRaw(
    requestParameters: CourierUserUpdateAllRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/update`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingUpdateAll200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   */
  async courierUserUpdateAll(
    requestParameters: CourierUserUpdateAllRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingUpdateAll200Response> {
    const response = await this.courierUserUpdateAllRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   */
  async courierUserUpsertWithWhereRaw(
    requestParameters: CourierUserUpsertWithWhereRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/upsertWithWhere`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   */
  async courierUserUpsertWithWhere(
    requestParameters: CourierUserUpsertWithWhereRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierUserUpsertWithWhereRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add all users to ShipCorp
   */
  async courierUserAddAllUsersToShipCorpRaw(
    requestParameters: CourierUserAddAllUsersToShipCorpRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToShipCorp().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-shipcorp`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to ShipCorp
   */
  async courierUserAddAllUsersToShipCorp(
    requestParameters: CourierUserAddAllUsersToShipCorpRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToShipCorpRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add all users to Logis
   */
  async courierUserAddAllUsersToLogisRaw(
    requestParameters: CourierUserAddAllUsersToLogisRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToLogis().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-logis`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to Logis
   */
  async courierUserAddAllUsersToLogis(
    requestParameters: CourierUserAddAllUsersToLogisRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToLogisRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add all users to ShipBiz
   */
  async courierUserAddAllUsersToShipBizRaw(
    requestParameters: { courierId: string },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToShipBiz.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-shipbiz`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId: requestParameters['courierId'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to ShipBiz
   */
  async courierUserAddAllUsersToShipBiz(
    requestParameters: { courierId: string },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToShipBizRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add all users to CargoJa
   */
  async courierUserAddAllUsersToCargoJaRaw(
    requestParameters: CourierUserAddAllUsersToCargoJaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToCargoJa.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-cargoja`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId: requestParameters['courierId'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to CargoJa
   */
  async courierUserAddAllUsersToCargoJa(
    requestParameters: CourierUserAddAllUsersToCargoJaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToCargoJaRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add all users to Farin2Yaad
   */
  async courierUserAddAllUsersToTrGlobalRaw(
    requestParameters: CourierUserAddAllUsersToTrGlobalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TrGlobalCustomerSyncResult>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToTrGlobal.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-trglobal`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId: requestParameters['courierId'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as TrGlobalCustomerSyncResult
    );
  }

  /**
   * Register all of this courier's customers with TR Global Logistics.
   * Incremental — only customers changed since the last successful sync are sent.
   */
  async courierUserAddAllUsersToTrGlobal(
    requestParameters: CourierUserAddAllUsersToTrGlobalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TrGlobalCustomerSyncResult> {
    const response = await this.courierUserAddAllUsersToTrGlobalRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  async courierUserAddAllUsersToFarin2YaadRaw(
    requestParameters: CourierUserAddAllUsersToFarin2YaadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToFarin2Yaad.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-farin2yaad`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId: requestParameters['courierId'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to Farin2Yaad
   */
  async courierUserAddAllUsersToFarin2Yaad(
    requestParameters: CourierUserAddAllUsersToFarin2YaadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToFarin2YaadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  async courierUserAddAllUsersToAtoraRaw(
    requestParameters: CourierUserAddAllUsersToAtoraRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierUserAddAllUsersToAtora.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/add-all-users-to-atora`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId: requestParameters['courierId'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(
      response,
      (jsonValue) => jsonValue as boolean
    );
  }

  /**
   * Add all users to Atora
   */
  async courierUserAddAllUsersToAtora(
    requestParameters: CourierUserAddAllUsersToAtoraRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierUserAddAllUsersToAtoraRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Change user password
   */
  async courierUserChangeUserPasswordRaw(
    requestParameters: { data: object },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (
      requestParameters.data === null ||
      requestParameters.data === undefined
    ) {
      throw new Error(
        'Required parameter requestParameters.data was null or undefined when calling courierUserChangeUserPassword.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/change-user-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.data as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Change user password
   */
  async courierUserChangeUserPassword(
    requestParameters: { data: object },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierUserChangeUserPasswordRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  async courierUserVerifyCodeRaw(
    requestParameters: VerifyCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ success: boolean; message: string }>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/verify-code`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  async courierUserVerifyCode(
    requestParameters: VerifyCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ success: boolean; message: string }> {
    const response = await this.courierUserVerifyCodeRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Request WhatsApp verification
   */
  async courierUserRequestWhatsAppVerificationRaw(
    requestParameters: CourierUserRequestWhatsAppVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<CourierUserRequestWhatsAppVerificationResponse>
  > {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserRequestWhatsAppVerification().'
      );
    }

    if (requestParameters['phoneNumber'] == null) {
      throw new runtime.RequiredError(
        'phoneNumber',
        'Required parameter "phoneNumber" was null or undefined when calling courierUserRequestWhatsAppVerification().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/request-whatsapp-verification`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Request WhatsApp verification
   */
  async courierUserRequestWhatsAppVerification(
    requestParameters: CourierUserRequestWhatsAppVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserRequestWhatsAppVerificationResponse> {
    const response = await this.courierUserRequestWhatsAppVerificationRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Login with WhatsApp code
   */
  async courierUserLoginWithWhatsAppCodeRaw(
    requestParameters: CourierUserLoginWithWhatsAppCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserLoginWithWhatsAppCodeResponse>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserLoginWithWhatsAppCode().'
      );
    }

    if (requestParameters['code'] == null) {
      throw new runtime.RequiredError(
        'code',
        'Required parameter "code" was null or undefined when calling courierUserLoginWithWhatsAppCode().'
      );
    }

    if (requestParameters['userId'] == null) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter "userId" was null or undefined when calling courierUserLoginWithWhatsAppCode().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/login-with-whatsapp-code`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Login with WhatsApp code
   */
  async courierUserLoginWithWhatsAppCode(
    requestParameters: CourierUserLoginWithWhatsAppCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserLoginWithWhatsAppCodeResponse> {
    const response = await this.courierUserLoginWithWhatsAppCodeRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Request SMS verification
   */
  async courierUserRequestSmsVerificationRaw(
    requestParameters: CourierUserRequestSmsVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<CourierUserRequestSmsVerificationResponse>
  > {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserRequestSmsVerification().'
      );
    }

    if (requestParameters['phoneNumber'] == null) {
      throw new runtime.RequiredError(
        'phoneNumber',
        'Required parameter "phoneNumber" was null or undefined when calling courierUserRequestSmsVerification().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/request-sms-verification`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Request SMS verification
   */
  async courierUserRequestSmsVerification(
    requestParameters: CourierUserRequestSmsVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserRequestSmsVerificationResponse> {
    const response = await this.courierUserRequestSmsVerificationRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Login with SMS code
   */
  async courierUserLoginWithSmsCodeRaw(
    requestParameters: CourierUserLoginWithSmsCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserLoginWithSmsCodeResponse>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserLoginWithSmsCode().'
      );
    }

    if (requestParameters['code'] == null) {
      throw new runtime.RequiredError(
        'code',
        'Required parameter "code" was null or undefined when calling courierUserLoginWithSmsCode().'
      );
    }

    if (requestParameters['userId'] == null) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter "userId" was null or undefined when calling courierUserLoginWithSmsCode().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/login-with-sms-code`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Login with SMS code
   */
  async courierUserLoginWithSmsCode(
    requestParameters: CourierUserLoginWithSmsCodeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserLoginWithSmsCodeResponse> {
    const response = await this.courierUserLoginWithSmsCodeRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Login with Apple
   */
  async courierUserLoginWithAppleRaw(
    requestParameters: CourierUserLoginWithAppleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserLoginWithAppleResponse>> {
    if (requestParameters['appleCredentials'] == null) {
      throw new runtime.RequiredError(
        'appleCredentials',
        'Required parameter "appleCredentials" was null or undefined when calling courierUserLoginWithApple().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/login-with-apple`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.appleCredentials,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Login with Apple
   */
  async courierUserLoginWithApple(
    requestParameters: CourierUserLoginWithAppleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserLoginWithAppleResponse> {
    const response = await this.courierUserLoginWithAppleRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Begin enrolling a passkey. Requires an authenticated caller; the returned
   * options go straight to startRegistration().
   */
  async courierUserPasskeyRegisterOptionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyOptionsResponse>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/register-options`,
        method: 'POST',
        headers: headerParameters,
        query: {},
        body: {},
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Begin enrolling a passkey
   */
  async courierUserPasskeyRegisterOptions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyOptionsResponse> {
    const response = await this.courierUserPasskeyRegisterOptionsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Finish enrolling a passkey with the authenticator's attestation
   */
  async courierUserPasskeyRegisterVerifyRaw(
    requestParameters: CourierUserPasskeyRegisterVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyRegisterVerifyResponse>> {
    if (requestParameters['credential'] == null) {
      throw new runtime.RequiredError(
        'credential',
        'Required parameter "credential" was null or undefined when calling courierUserPasskeyRegisterVerify().'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/register-verify`,
        method: 'POST',
        headers: headerParameters,
        query: {},
        body: {
          credential: requestParameters['credential'],
          name: requestParameters['name'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Finish enrolling a passkey
   */
  async courierUserPasskeyRegisterVerify(
    requestParameters: CourierUserPasskeyRegisterVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyRegisterVerifyResponse> {
    const response = await this.courierUserPasskeyRegisterVerifyRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Begin a passkey sign-in. Unauthenticated. Omit `email` for the
   * discoverable flow, where the browser picks the account.
   */
  async courierUserPasskeyLoginOptionsRaw(
    requestParameters: CourierUserPasskeyLoginOptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyOptionsResponse>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserPasskeyLoginOptions().'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/login-options`,
        method: 'POST',
        headers: headerParameters,
        query: {},
        body: {
          realm: requestParameters['realm'],
          ...(requestParameters['email'] ? { email: requestParameters['email'] } : {}),
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Begin a passkey sign-in
   */
  async courierUserPasskeyLoginOptions(
    requestParameters: CourierUserPasskeyLoginOptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyOptionsResponse> {
    const response = await this.courierUserPasskeyLoginOptionsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Finish a passkey sign-in and receive an access token
   */
  async courierUserPasskeyLoginVerifyRaw(
    requestParameters: CourierUserPasskeyLoginVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyLoginResponse>> {
    if (requestParameters['realm'] == null) {
      throw new runtime.RequiredError(
        'realm',
        'Required parameter "realm" was null or undefined when calling courierUserPasskeyLoginVerify().'
      );
    }
    if (requestParameters['credential'] == null) {
      throw new runtime.RequiredError(
        'credential',
        'Required parameter "credential" was null or undefined when calling courierUserPasskeyLoginVerify().'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/login-verify`,
        method: 'POST',
        headers: headerParameters,
        query: {},
        body: {
          realm: requestParameters['realm'],
          credential: requestParameters['credential'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Finish a passkey sign-in
   */
  async courierUserPasskeyLoginVerify(
    requestParameters: CourierUserPasskeyLoginVerifyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyLoginResponse> {
    const response = await this.courierUserPasskeyLoginVerifyRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * List the calling user's enrolled passkeys
   */
  async courierUserPasskeyListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyListResponse>> {
    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/credentials`,
        method: 'GET',
        headers: headerParameters,
        query: {},
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * List enrolled passkeys
   */
  async courierUserPasskeyList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyListResponse> {
    const response = await this.courierUserPasskeyListRaw(initOverrides);
    return await response.value();
  }

  /**
   * Rename one of the calling user's passkeys
   */
  async courierUserPasskeyRenameRaw(
    requestParameters: CourierUserPasskeyRenameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserPasskeyRegisterVerifyResponse>> {
    if (requestParameters['credentialId'] == null) {
      throw new runtime.RequiredError(
        'credentialId',
        'Required parameter "credentialId" was null or undefined when calling courierUserPasskeyRename().'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/credentials/{credentialId}`.replace(
          `{${'credentialId'}}`,
          encodeURIComponent(String(requestParameters['credentialId']))
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: {},
        body: { name: requestParameters['name'] },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Rename a passkey
   */
  async courierUserPasskeyRename(
    requestParameters: CourierUserPasskeyRenameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserPasskeyRegisterVerifyResponse> {
    const response = await this.courierUserPasskeyRenameRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Delete one of the calling user's passkeys
   */
  async courierUserPasskeyDeleteRaw(
    requestParameters: CourierUserPasskeyDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ success: boolean }>> {
    if (requestParameters['credentialId'] == null) {
      throw new runtime.RequiredError(
        'credentialId',
        'Required parameter "credentialId" was null or undefined when calling courierUserPasskeyDelete().'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/passkey/credentials/{credentialId}`.replace(
          `{${'credentialId'}}`,
          encodeURIComponent(String(requestParameters['credentialId']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: {},
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Delete a passkey
   */
  async courierUserPasskeyDelete(
    requestParameters: CourierUserPasskeyDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ success: boolean }> {
    const response = await this.courierUserPasskeyDeleteRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Delete user account
   */
  async courierUserDeleteAccountRaw(
    requestParameters: CourierUserDeleteAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserDeleteAccountResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierUserDeleteAccount().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token =
        this.configuration.accessToken &&
        (await this.configuration.accessToken('accessToken', []));
      if (token) {
        headerParameters['Authorization'] = token;
      }
    }

    const response = await this.request(
      {
        path: `/CourierUsers/delete-account/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Delete user account
   */
  async courierUserDeleteAccount(
    requestParameters: CourierUserDeleteAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserDeleteAccountResponse> {
    const response = await this.courierUserDeleteAccountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Get the next manifest number for an isCourier user (raw)
   */
  async courierUserGetNextManifestNumberRaw(
    requestParameters: CourierUserGetNextManifestNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUserGetNextManifestNumberResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling courierUserGetNextManifestNumber.'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierUsers/{id}/getNextManifestNumber`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Get the next manifest number for an isCourier user
   * Returns format: {prefix}{6-digit sequence} e.g., ABC000001
   */
  async courierUserGetNextManifestNumber(
    requestParameters: CourierUserGetNextManifestNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUserGetNextManifestNumberResponse> {
    const response = await this.courierUserGetNextManifestNumberRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
